import { SelectType } from '@ais-ui/ui-core';
import {
  coverageReportMiscellaneous,
  csvDataExportReportMiscellaneous,
} from '../../reportsTypes';

export const parseCoverageMiscellaneousPlotType = (
  inputValue: string
): SelectType | undefined => {
  const plotTypeOptions = coverageReportMiscellaneous.plotType.options;

  if (!plotTypeOptions) {
    return;
  }

  for (const plotTypeOption of plotTypeOptions) {
    if (inputValue.toLowerCase() === plotTypeOption.value.toLowerCase()) {
      return plotTypeOption.value;
    }
  }
  return;
};
